import {
  Box,
  TextField,
  MenuItem,
  Typography,
  Tooltip,
} from '@material-ui/core'

const SelectPaymentMethod = ({ items, anotherOption = false, ...rest }) => {
  return (
    <Box>
      <Typography variant="body1" color="textSecondary">
        Pague com
      </Typography>
      <TextField
        select
        fullWidth
        variant="outlined"
        {...rest}
        size="small"
        required
      >
        {items.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            <Box width="100%" display="flex" flexDirection="row">
              {item.image}
              <Tooltip title={item.name || ''} placement="top">
                <Typography>{item.name}</Typography>
              </Tooltip>
            </Box>
          </MenuItem>
        ))}
        {anotherOption && (
          <MenuItem key="another" value="another">
            Outro
          </MenuItem>
        )}
      </TextField>
    </Box>
  )
}

export default SelectPaymentMethod
